import { render, staticRenderFns } from "./FinancialHub.vue?vue&type=template&id=dfcda9a6&scoped=true"
import script from "./FinancialHub.vue?vue&type=script&lang=js"
export * from "./FinancialHub.vue?vue&type=script&lang=js"
import style0 from "./FinancialHub.vue?vue&type=style&index=0&id=dfcda9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcda9a6",
  null
  
)

export default component.exports